import React, { useRef, useEffect, useState } from 'react'
import styled from 'styled-components'
import Theme, { MyTheme } from 'Components/common/Theme'
import { getConfigByKey, getRequestString, numberWithComma } from 'helpers/format'
import { Data, Product } from 'Store/orders/types'
import { Col, Dropdown, Image, Rate, Row, Space, Tag } from 'antd'
import { appConfig } from 'config'
import { TableListPage } from 'Components/common/Table'
import {
  AuditOutlined,
  PrinterOutlined,
  StarFilled,
  StarOutlined,
  ThunderboltOutlined,
} from '@ant-design/icons'
import { PrimaryButton } from 'Components/button'
import { APIPath } from 'services/APIPath'
import ReceiptPDF from './ReceiptPDF'
import ReactToPrint from 'react-to-print'
import { DocumentConfigKey, DocumentDefaultTitle, ImageFallback, OrderStatus } from 'helpers/constanst'
import InvoicePDF from './InvoicePDF'
import { selectPosBill } from 'Store/orders/selector'
import RootState from 'typings/RootState'
import { connect, useDispatch } from 'react-redux'
import GrnTransfer from './GrnTransfer'
import { selectConfigList, selectIsPackageC } from 'Store/pos/selector'
import { GrnProductsListReq, SelectedProductsGrn } from 'Store/stock/types'
import { getProductsGrnListAPI } from 'Store/stock/api'
import { selectCurrentUser } from 'Store/user/selector'
import { selectProductsGrnEvent, selectProductsGrnList } from 'Store/stock/selector'
import { LoadingView } from 'Components/modal'
import _, { cloneDeep } from 'lodash'
import OrderSummary from './OrderSummary'
import { ReturnTag } from 'Components/utilities'
import { MenuPrints } from 'Components/form'
import { ProductOptions } from 'Store/product/types'
import ProductUomSystemInfo from 'Pages/Product/components/ProductUomSystemInfo'

type Props = {
  detail?: Data
  merchantId: number
  orderNo: string
  isPublicDelivery?: boolean
  status: OrderStatus
  selectedGrn: SelectedProductsGrn[]
  setSelectedGrn: (selected: SelectedProductsGrn[]) => void
  showSummary?: boolean
  ignoreReturn?: boolean
} & ReduxProps

const ProductsInfo: React.FunctionComponent<Props> = props => {
  const {
    detail,
    merchantId,
    orderNo,
    isPublicDelivery = false,
    status,
    billData,
    //isPackageC,
    currentUser,
    productsGrn,
    productsGrnEvent,
    selectedGrn,
    setSelectedGrn,
    showSummary = true,
    ignoreReturn = false,
    configList,
  } = props
  const isPos = detail?.channel === 'pos'
  const dispatch = useDispatch()
  // const [selectedGrn, setSelectedGrn] = useState([] as SelectedProductsGrn[])
  const invoicePrintPDF = useRef(null as any)
  const invoicePrintPDFLite = useRef(null as any)
  const receiptPrintPDF = useRef(null as any)
  const [invoicePDFtitle, setInvoicePDFtitle] = useState(DocumentDefaultTitle.DELIVERY as string)
  const req = {
    merchant_id: merchantId,
    order_no: orderNo,
  }
  const bestPdfEndpoint = `${appConfig.apiExpressEndpoint}${APIPath.createBestTracking}?${getRequestString(
    req,
  )}`
  const trackingNumber = detail?.products[0]?.products[0]?.shipping_detail?.tracking_number || ''
  const hasTrackingNumber = trackingNumber !== ''
  const products = detail?.products[0]?.products || []
  const isPackageC = detail?.products[0]?.package_level == '3'
  const configData = getConfigByKey(configList, DocumentConfigKey.DELIVERY)
  const config = configData && configData?.config_value && JSON.parse(configData?.config_value || '')

  const getProductOptionID = () => {
    const ids = [] as {
      product_id: number
      product_option_id: number
    }[]
    detail &&
      detail.products &&
      detail.products.forEach(item => {
        if (item && item.products) {
          item.products.forEach(product => {
            ids.push({
              product_id: product.product_id,
              product_option_id: product.product_option_id,
            })
          })
        }
      })
    return ids
  }

  const getGrns = (product_id: number, product_option_id: number) => {
    const grns =
      productsGrn &&
      productsGrn.find(item => item.product_id === product_id && item.product_option_id === product_option_id)

    return grns ? grns.product_grn_items : []
  }

  const onSetSelectedGrn = (
    product_id: number,
    product_option_id: number,
    grn_item_ids: number[],
    quantity: number,
  ) => {
    const newSelect = [] as SelectedProductsGrn[]
    const hasProduct = cloneDeep(selectedGrn).find(
      item => item.product_id === product_id && item.product_option_id === product_option_id,
    )
    if (!_.isEmpty(hasProduct)) {
      selectedGrn.forEach(item => {
        if (item.product_id === product_id && item.product_option_id === product_option_id) {
          item.grn_item_ids = grn_item_ids
        }
        newSelect.push(item)
      })
    } else {
      newSelect.push({
        grn_item_ids: grn_item_ids,
        product_id: product_id,
        product_option_id: product_option_id,
        quantity: quantity,
      })
    }

    setSelectedGrn([...newSelect])
  }

  const getSelectedGrn = (product_id: number, product_option_id: number) => {
    const grns =
      selectedGrn &&
      selectedGrn.find(item => item.product_id === product_id && item.product_option_id === product_option_id)

    return grns ? grns.grn_item_ids : []
  }

  const onGetProductsGrn = (): void => {
    const req: GrnProductsListReq = {
      product_ids: getProductOptionID(),
      is_out_of_stock: false,
      all: false,
    }
    dispatch(getProductsGrnListAPI(req, currentUser.accessToken, currentUser?.activeMerchant?.uuid || ''))
  }

  useEffect(() => {
    if (detail && isPackageC && status === OrderStatus.SUCCESS) {
      onGetProductsGrn()
    }
  }, [detail])

  useEffect(() => {
    // default grn
    if (productsGrn) {
      const newSelect = [] as SelectedProductsGrn[]
      productsGrn.forEach(item => {
        let count = 0
        const target = [] as any[]
        const findProduct =
          detail?.products &&
          detail?.products[0].products.find(
            product =>
              product.product_id === item.product_id && product.product_option_id === item.product_option_id,
          )
        if (findProduct?.product_option?.bom === 1) return
        const quantity = findProduct?.quantity_system || 0

        item?.product_grn_items &&
          item.product_grn_items.forEach(grn => {
            if (count > quantity) return
            if (grn.item.amount_system > 0) {
              target.push(grn.item.id)
              count += grn.item.amount_system
            }
          })
        newSelect.push({
          grn_item_ids: target,
          product_id: item.product_id,
          product_option_id: item.product_option_id,
          quantity: quantity,
        })
      })
      setSelectedGrn([...newSelect])
    }
  }, [productsGrn])

  const renderInfo = (val: any) => {
    return <RowTile>{val}</RowTile>
  }

  const renderImage = (product_option: any) => (
    <ThumbImage src={appConfig.assetCdnEndpoint + product_option?.photo} fallback={ImageFallback} />
  )

  const renderProductName = (item: any, record: any) => {
    const isSameTitle = item.title == record.product_option?.title
    const isFlashSale = record.product_option?.promotion?.promotion_type === 'flash_sale'
    const promotionName = record.product_option?.promotion?.name || 'Promotion'
    // const isBom = record.product_option?.bom === 1
    return (
      <>
        <RowTile>{item.title}</RowTile>
        {/* {isBom && <Tag color={theme.colors.primary}>สินค้ามีส่วนประกอบ</Tag>} */}
        {!isSameTitle && <ProductDesc>{record.product_option?.title}</ProductDesc>}
        {isFlashSale && (
          <Tag icon={<ThunderboltOutlined />} color={Theme.colors.primary}>
            {promotionName}
          </Tag>
        )}
        {/* <ReturnTag isReturn={record?.product?.refund_status === 'Y'} /> */}
        <ReturnTag
          isReturn={record?.product?.return_qty > 0}
          returnQty={record?.product?.return_qty}
          returnUom={record?.product_uom_system}
        />
      </>
    )
  }

  const getReviewInfo = (record: Product) => {
    return (
      <Review>
        {record?.review ? (
          <Row>
            <Col span={24}>
              <Space size="middle" align="center">
                <InfoTitle>คะแนนรีวิว</InfoTitle>
                <Rate disabled defaultValue={record?.review_detail?.score || 0} />
                <InfoValue>({record?.review_detail?.score} คะแนน)</InfoValue>
              </Space>
            </Col>
            {record?.review_detail?.comment !== '' && (
              <Col span={24}>
                <Space size="small" align="center">
                  <InfoTitle>ความคิดเห็น</InfoTitle>
                  <InfoValue>{record?.review_detail?.comment}</InfoValue>
                </Space>
              </Col>
            )}
          </Row>
        ) : (
          'ยังไม่มีคะแนนรีวิว'
        )}
      </Review>
    )
  }

  const renderProductUom = (uom: string, record: Product) => {
    return (
      <ProductUomSystemInfo
        multiplier={record.multiplier}
        quantity={record.quantity}
        uom={record.product_uom}
        quantitySystem={record.quantity_system}
        uomSystem={record.product_uom_system}
        showQuantity={false}
      />
    )
  }

  const renderQuantity = (quantity: number, record: Product) => {
    const uom = (
      <ProductUomSystemInfo
        multiplier={record.multiplier}
        quantity={record.quantity}
        uom={record.product_uom}
        quantitySystem={record.quantity_system}
        uomSystem={record.product_uom_system}
        showQuantity={true}
      />
    )
    return (
      <Space>
        {numberWithComma(quantity)}
        {uom}
      </Space>
    )
  }

  const getGrnInfo = (record: Product) => {
    if (record?.product_option?.bom === 1) {
      return (
        <span>
          สินค้ามีส่วนประกอบ​ จะตัดสต๊อกของส่วนประกอบแบบเลือก GRN อัตโนมัติ
          โดยเรียงลำดับตามการนำสินค้าเข้าคลัง (First In, First Out)
        </span>
      )
    }

    const grnItems = getGrns(record.product_id, record.product_option_id) || []
    console.log('record', record)
    return (
      <Review>
        {grnItems && grnItems.length > 0 && (
          <Row>
            <Col span={24}>
              <GrnTransfer
                amount={record?.quantity_system || 0}
                uom={record?.product_uom_system || ''}
                productGrn={grnItems}
                onSetSelectedGrn={grn_item_ids =>
                  onSetSelectedGrn(
                    record.product_id,
                    record.product_option_id,
                    grn_item_ids,
                    record?.quantity_system || 0,
                  )
                }
                targetKeys={getSelectedGrn(record.product_id, record.product_option_id)}
              />
            </Col>
          </Row>
        )}
      </Review>
    )
  }

  const getIcon = (props: any) => {
    const { onExpand, record } = props
    const styleIcon = { color: Theme.colors.grey, fontSize: '20px' }
    return record?.review ? (
      <StarFilled style={{ ...styleIcon, color: '#fadb14' }} onClick={e => onExpand(record, e)} />
    ) : (
      <StarOutlined style={styleIcon} onClick={e => onExpand(record, e)} />
    )
  }

  const getGrnIcon = (props: any) => {
    const { onExpand, record, expanded } = props
    if (!expanded) {
      onExpand(record, null)
    }
    return <Space direction="vertical" align="start"></Space>
  }

  const reviewContent = {
    expandedRowRender: getReviewInfo,
    fixed: 'left',
    expandIconColumnIndex: 10,
    defaultExpandAllRows: false,
    // eslint-disable-next-line react/display-name
    expandIcon: getIcon,
  }

  const grnContent = {
    expandedRowRender: getGrnInfo,
    // expandedRowRender: (record: Product) =>
    //   record?.product_option?.bom === 1 ? <span /> : getGrnInfo(record),
    fixed: 'left',
    expandIconColumnIndex: 0,
    defaultExpandAllRows: true,
    // eslint-disable-next-line react/display-name
    expandIcon: getGrnIcon,
    columnWidth: '0',
    childrenColumnName: 'การตัดสินค้าออกจากสต๊อก',
    showExpandColumn: true,
  }

  const expandContent =
    status === OrderStatus.DELIVERED || status === OrderStatus.CONFIRM_RECEICVED
      ? reviewContent
      : status === OrderStatus.SUCCESS && isPackageC
      ? grnContent
      : {
          defaultExpandAllRows: true,
        }

  const columns = [
    {
      title: <ColTile>ลำดับ</ColTile>,
      dataIndex: 'no',
      key: 'no',
      // eslint-disable-next-line react/display-name
      render: (value: any, record: any, index: number) => {
        return renderInfo(index + 1)
      },
      width: '50px',
    },
    {
      title: <ColTile>รูปภาพ</ColTile>,
      dataIndex: 'product_option',
      key: 'product_option',
      render: renderImage,
    },
    {
      title: <ColTile>รหัสสินค้า</ColTile>,
      dataIndex: 'product',
      key: 'product-code',
      render: (product: any) => renderInfo(product?.code || '-'),
    },
    {
      title: <ColTile>รายการ</ColTile>,
      dataIndex: 'product',
      key: 'product-title',
      render: renderProductName,
      width: '150px',
    },
    {
      title: <ColTile>ยี่ห้อ</ColTile>,
      dataIndex: 'product',
      key: 'manufacturer',
      render: (product: any) => renderInfo(product?.manufacturer?.name || '-'),
    },
    {
      title: <ColTile>จำนวน</ColTile>,
      dataIndex: 'quantity',
      key: 'quantity',
      render: (quantity: number) => renderInfo(numberWithComma(quantity)),
    },
    {
      title: <ColTile>หน่วย</ColTile>,
      dataIndex: 'product_uom',
      key: 'product_uom',
      render: renderProductUom,
      //render: (product: any) => renderInfo(product?.uom?.name || '-'),
    },
    {
      title: (
        <ColTile>
          ราคารวม
          <ProductDesc>(ก่อนหักส่วนลด)</ProductDesc>
        </ColTile>
      ),
      dataIndex: 'price_before_discount',
      key: 'price_before_discount',
      render: (price: number) => renderInfo(numberWithComma(price, true)),
    },
    {
      title: <ColTile>ส่วนลด</ColTile>,
      dataIndex: 'total_discount',
      key: 'total_discount',
      render: (price: number) => renderInfo(numberWithComma(price, true)),
    },
    {
      title: (
        <ColTile>
          ราคารวม
          <ProductDesc>(หลังหักส่วนลด)</ProductDesc>
        </ColTile>
      ),
      dataIndex: 'total_price',
      key: 'total_price',
      render: (price: number) => renderInfo(numberWithComma(price, true)),
    },
  ]

  const terminalColumns = [
    {
      title: <ColTile>ลำดับ</ColTile>,
      dataIndex: 'no',
      key: 'no',
      // eslint-disable-next-line react/display-name
      render: (value: any, record: any, index: number) => {
        return renderInfo(index + 1)
      },
      width: '50px',
    },
    {
      title: <ColTile>รูปภาพ</ColTile>,
      dataIndex: 'product_option',
      key: 'product_option',
      render: renderImage,
    },
    {
      title: <ColTile>รหัสสินค้า</ColTile>,
      dataIndex: 'product',
      key: 'product-code',
      render: (product: any) => renderInfo(product?.code || '-'),
    },
    {
      title: <ColTile>รายการ</ColTile>,
      dataIndex: 'product',
      key: 'product-title',
      render: renderProductName,
      width: '150px',
    },
    {
      title: <ColTile>ยี่ห้อ</ColTile>,
      dataIndex: 'product',
      key: 'manufacturer',
      render: (product: any) => renderInfo(product?.manufacturer?.name || '-'),
    },
    {
      title: <ColTile>จำนวน</ColTile>,
      dataIndex: 'quantity',
      key: 'quantity',
      render: renderQuantity,
    },
    // {
    //   title: <ColTile>หน่วย</ColTile>,
    //   dataIndex: 'product',
    //   key: 'uom',
    //   render: (product: any) => renderInfo(product?.uom?.name || '-'),
    // },
    // {
    //   title: <ColTile>หน่วย</ColTile>,
    //   dataIndex: 'product_uom',
    //   key: 'product_uom',
    //   render: renderProductUom,
    //   //render: (product: any) => renderInfo(product?.uom?.name || '-'),
    // },
    {
      title: <ColTile>ราคา/หน่วย</ColTile>,
      dataIndex: 'price_before_discount_per_unit',
      key: 'price_before_discount_per_unit',
      render: (val: number) => renderInfo(numberWithComma(val || 0, true)),
    },
    {
      title: <ColTile>ส่วนลด/หน่วย</ColTile>,
      dataIndex: 'discount',
      key: 'discount',
      render: (val: number) => renderInfo(numberWithComma(val || 0, true)),
    },
    {
      title: <ColTile>ราคารวม</ColTile>,
      dataIndex: 'total_price',
      key: 'total_price',
      render: (price: number) => renderInfo(numberWithComma(price, true)),
    },
  ]

  const filterProducts = (products: Product[]) => {
    if (ignoreReturn) {
      return products && products?.filter(item => item.product?.refund_status !== 'Y')
    } else {
      return products
    }
  }

  return (
    <BoxWrapper>
      <Row gutter={[16, 16]}>
        <Col span={24}>
          <Row justify="space-between" gutter={[32, 32]} align="middle">
            <Col>
              <BoxTitle>สรุปคำสั่งซื้อ </BoxTitle>
            </Col>
            <Col>
              <Space>
                <Dropdown
                  key="more"
                  overlay={
                    <MenuPrints
                      nomalPrintRef={invoicePrintPDF}
                      litePrintRef={invoicePrintPDFLite}
                      title={`${invoicePDFtitle}-${detail?.order_no}`}
                      titleSelection={config?.header || null}
                      onSelectTitle={setInvoicePDFtitle}
                    />
                  }
                  trigger={['click', 'hover']}
                >
                  <PrimaryButton
                    btnType="Primary"
                    text="ใบส่งสินค้า"
                    icon={<PrinterOutlined />}
                    onClick={() => {}}
                    size="middle"
                  />
                </Dropdown>
                {isPos && billData && (
                  <ReactToPrint
                    trigger={() => {
                      return (
                        <PrimaryButton
                          icon={<AuditOutlined />}
                          text="ใบเสร็จ"
                          btnType="Approve"
                          onClick={() => {}}
                          size="middle"
                        />
                      )
                    }}
                    content={() => receiptPrintPDF.current}
                    documentTitle={`ใบเสร็จ-${detail?.order_no}`}
                  />
                )}

                {isPublicDelivery && hasTrackingNumber && (
                  <a href={bestPdfEndpoint} target="_bank">
                    <PrimaryButton
                      icon={<PrinterOutlined />}
                      text="ใบปะหน้าซอง"
                      btnType="Cancel"
                      size="middle"
                    />
                  </a>
                )}
              </Space>
            </Col>
          </Row>
          <TableListPage
            columns={isPos ? terminalColumns : columns}
            datas={filterProducts(products)}
            scrollX={800}
            size={'small'}
            expandable={expandContent}
            //rowClassName={(record: Product) => (record?.product?.refund_status === 'Y' ? 'row-disabled' : '')}
            // rowClassName={(record: Product) =>
            //   (record?.product?.return_qty || 0) >= record?.quantity ? 'row-disabled' : ''
            // }
          />
        </Col>
      </Row>
      {showSummary && <OrderSummary detail={detail} />}

      <Row ref={invoicePrintPDF}>
        <Col span={24}>
          <InvoicePDF detail={detail} title={invoicePDFtitle} configData={configData} />
        </Col>
      </Row>
      <Row ref={invoicePrintPDFLite}>
        <Col span={24}>
          <InvoicePDF detail={detail} isLite title={invoicePDFtitle} configData={configData} />
        </Col>
      </Row>
      {isPos && (
        <Row ref={receiptPrintPDF}>
          <Col span={24}>
            <ReceiptPDF detail={detail} />
          </Col>
        </Row>
      )}
      <LoadingView isShow={productsGrnEvent?.IsLoading} />
    </BoxWrapper>
  )
}

const BoxTitle = styled.div`
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body3};
  font-family: ${(props: { theme: MyTheme }): string => props.theme.fontFamily.primary};
`

const BoxWrapper = styled.div`
  width: 100%;
  border-radius: 10px;
  padding: 15px 10px;
  //border: 1px solid ${(props: { theme: MyTheme }): string => props.theme.colors.whitebg};
  border: 1px solid #f0f0f0;
  margin-bottom: 10px;
  background-color:  ${(props: { theme: MyTheme }): string => props.theme.colors.white};
`

const ThumbImage = styled(Image)`
  border-radius: 5px;
  width: 70px;
  height: 70px;
  object-fit: cover;
`

const ColTile = styled.span`
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body4};
`

const RowTile = styled.div`
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body4};
`

const ProductDesc = styled(RowTile)`
  color: ${(props: { theme: MyTheme }): string => props.theme.colors.grey};
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body5};
`

const InfoTitle = styled.span`
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body4};
  color: ${(props: { theme: MyTheme }): string => props.theme.colors.grey};
`

const InfoValue = styled.span`
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body4};
  color: ${(props: { theme: MyTheme }): string => props.theme.colors.black};
  margin-right: 10px;
`

const Review = styled.div``

const mapStateToProps = (state: RootState) => {
  return {
    billData: selectPosBill(state),
    isPackageC: selectIsPackageC(state),
    currentUser: selectCurrentUser(state),
    productsGrn: selectProductsGrnList(state),
    productsGrnEvent: selectProductsGrnEvent(state),
    configList: selectConfigList(state),
  }
}

type ReduxProps = ReturnType<typeof mapStateToProps>

export default connect(mapStateToProps)(ProductsInfo)
